// @ts-nocheck

import React from 'react';
import { Breadcrumbs, Typography } from '@mui/material';
import DoubleArrow from '../../../../assets/DoubleArrow.png';

interface BreadcrumbComponentProps {
  steps?: string[];
  currentStep?: number;
  setCurrentStep?: (step: number) => void;
}

const BreadcrumbComponent: React.FC<BreadcrumbComponentProps> = ({ steps, currentStep, setCurrentStep }) => {
  return (
    <Breadcrumbs
      sx={{
        pt: 2,
        whiteSpace: 'nowrap',
        '.MuiBreadcrumbs-separator': {
          mx: { xs: 0, sm: 1 },
        },
        '.MuiBreadcrumbs-ol': {
          flexWrap: 'nowrap',
        },
      }}
      aria-label="breadcrumb"
      separator={
        <>
          <img src={DoubleArrow} alt="arrow" height={10} width={20} data-testid="breadcrumb-separator" />
        </>
      }
      className="flex justify-center md:mb-6"
      data-testid="breadcrumb-container"
    >
      {steps.map((step, index) => {
        const isClickable = currentStep >= index;

        return (
          <Typography
            key={index}
            component="span"
            onClick={() => isClickable && setCurrentStep(index)} // Only allow going back or to current step
            tabIndex={isClickable ? 0 : -1} // Keyboard focus only on available steps
            aria-current={currentStep === index ? 'step' : undefined}
            sx={{
              cursor: isClickable ? 'pointer' : 'default',
              fontSize: { xs: '12px', md: currentStep === index ? '1.2rem' :"1rem" },
              px: { sm: 2 },
              color:
                currentStep === index
                  ? '#FF5C39'
                  : currentStep > index
                  ? '#3B3B3B'
                  : '#ABB7C2',
            }}
            data-testid={`breadcrumb-step-${index}`}
          >
            {step}
          </Typography>
        );
      })}
    </Breadcrumbs>
  );
};

export default BreadcrumbComponent;
